// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';

// TODO: Import MUI icon

// TODO: Import custom component

export default function Slogan({ id, slogan }) {
    // TODO: Define useContext

    // TODO: Define variable
    const [checked, setChecked] = React.useState(false);
    const [textArrayIndex, setTextArrayIndex] = React.useState(-1);
    const fadeTime = 5000;

    // TODO: Define event
    React.useEffect(() => {
        if (slogan.length > 0) {
            setTextArrayIndex(0);
        }
    }, [slogan]);

    React.useEffect(() => {
        if (textArrayIndex >= 0) {
            setChecked((prev) => !prev);
            setTimeout(() => {
                if (slogan.length > 1) {
                    setChecked((prev) => !prev);
                }
            }, fadeTime - 1000);
            setTimeout(() => {
                const idx = textArrayIndex;
                if (idx === slogan.length - 1) {
                    setTextArrayIndex(0);
                } else {
                    setTextArrayIndex(idx + 1);
                }
            }, fadeTime);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textArrayIndex]);

    // TODO: Define function

    // TODO: Return component
    return (
        <Box
            sx={{
                backgroundImage: `url("https://www.pohtyh.edu.hk/YiYuan/images/plants/${id}/cover.jpg")`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: `calc(100vw * 9 / 16)`,
            }}
        >
            <Fade in={checked} timeout={{ enter: 1000, exit: 1000 }}>
                <Typography
                    component="p"
                    gutterBottom
                    sx={{
                        color: '#FFF',
                        fontWeight: 'bold',
                        fontSize: { xs: '3rem', md: '5rem' },
                        textShadow: '0px 0px 10px #000',
                    }}
                    variant="h1"
                >
                    {textArrayIndex >= 0 && slogan[textArrayIndex]}
                </Typography>
            </Fade>
        </Box>
    );
}